//越南语
export default {
    今日涨跌:"Biến động hôm nay",
    商品:"Hàng hóa",
    交割:"Vận chuyển",
关于我们:"về chúng tôi",
账变记录:"Hồ sơ thay đổi tài khoản",
股票:"Cổ phần",
加密货币:"tiền điện tử",
加载中:"đang tải...",
已经全部加载完毕:"Tất cả đã được tải",
暂无记录:"Không có hồ sơ",
高级认证:"Chứng nhận nâng cao",
姓名:"Tên",
请输入姓名:"Vui lòng nhập tên của bạn",
护照编号:"Số hộ chiếu",
请输入护照编号:"Vui lòng nhập số hộ chiếu",
护照照片:"ảnh hộ chiếu",
申请认证:"Nộp đơn xin chứng nhận",
提示:"gợi ý",
确定:"Chắc chắn",
提交失败:"Gửi không thành công",
上传失败:"Tải lên thất bại",
身份认证:"Xác thực",
身份证号:"số ID",
请输入身份证号:"Vui lòng nhập số nhận dạng",
  全球领先的期货和数字资产平台: "Nền tảng hàng đầu toàn cầu về giao dịch tương lai và tài sản số",
身份证照片:"ảnh giấy tờ tùy thân",
申请认证:"Nộp đơn xin chứng nhận",
修改资金密码:"Thay đổi mật khẩu quỹ",
旧密码:"Mật khẩu cũ",
请输入旧密码:"Vui lòng nhập mật khẩu cũ",
新密码:"mật khẩu mới",
请输入6位数字:"Vui lòng nhập 6 chữ số",
确认新密码:"Xác nhận mật khẩu mới",
请再次输入新密码:"Vui lòng nhập lại mật khẩu mới",
提交:"nộp",
请输入新密码:"Vui lòng nhập mật khẩu mới",
请输入6位数新密码:"Vui lòng nhập mật khẩu mới gồm 6 chữ số",
请确认两次密码输入一致:"Vui lòng xác nhận rằng hai mật khẩu đã nhập là nhất quán",
修改登录密码:"Thay đổi mật khẩu đăng nhập",
密码长度:"Mật khẩu (6-12 ký tự)",
密码长度提示:"Vui lòng nhập 6-12 ký tự, bao gồm số hoặc chữ cái",
客服:"dịch vụ khách hàng",
永续:"Bền vững",
交割:"Vận chuyển",
永续合约:"Hợp đồng vĩnh viễn",
交割合约:"Hợp đồng giao hàng",
全仓:"Kho đầy đủ",
开多:"Mở lâu",
开空:"Mở ngắn",
价格:"giá",
开仓金额:"Số tiền mở",
可用金额:"Số tiền có sẵn",
合约金额:"Giá trị hợp đồng",
保证金:"lề",
手续费:"phí xử lý",
看涨:"lạc quan",
看跌:"Giảm giá",
交割时间:"thời gian giao hàng",
数量:"Số lượng",
持有仓位:"Giữ một vị trí",
当前委托:"Thứ tự hiện tại",
历史订单:"Lệnh lịch sử",
暂无数据:"Không có dữ liệu",
购买价:"giá mua",
市价: "Giá thị trường",
限价: "giới hạn giá",
现价:"Giá hiện tại",
金额:"Số lượng",
盈亏:"Lợi nhuận và thua lỗ",
操作:"vận hành",
平仓:"Đóng vị thế",
撤单:"Hủy đơn hàng",
方向:"phương hướng",
剩余时间:"thời gian còn lại",
交割时间:"thời gian giao hàng",
详情:"Chi tiết",
名称:"tên",
最新价格:"giá mới nhất",
h24涨跌:"Thăng trầm 24H",
h24涨跌幅:"Tăng giảm 24h",
请输入开仓金额:"Vui lòng nhập số tiền mở",
请输入开仓价格:"Vui lòng nhập giá mở cửa",
确定执行撤单操作:"Bạn có chắc chắn muốn hủy đơn hàng không?",
确定执行平仓操作:"Bạn có chắc chắn thực hiện thao tác đóng vị thế không?",
交割合约历史:"Lịch sử hợp đồng giao hàng",
历史仓位:"Vị trí lịch sử",
到期时间:"Hạn sử dụng",
闪兑:"Trao đổi flash",
从:"từ",
最大:"tối đa",
可用数量:"Số lượng hiện có sẵn",
至:"ĐẾN",
复制成功:"Đã sao chép thành công",
基金理财:"Quản lý tài chính quỹ",
托管金额:"Số tiền ký quỹ",
总收益:"Tổng doanh thu",
当日收益:"Thu nhập trong ngày",
托管订单:"Lệnh ký quỹ",
规则:"luật lệ",
日收益:"Thu nhập hàng ngày",
限额:"giới hạn",
周期:"xe đạp",
天:"bầu trời",
立即买入:"Mua ngay",
购买:"Mua",
购买日:"ngày mua",
起息日:"ngày giá trị",
派息时间:"Thời gian trả cổ tức",
每日:"hằng ngày",
计息结束日:"Ngày kết thúc tích lũy lãi",
提前赎回:"sự chuộc lỗi sớm",
预计收益:"Doanh thu được ước tính",
今日日收益:"Hôm nay (thu nhập hàng ngày)",
最少可投:"Đầu tư tối thiểu",
最大可投:"Đầu tư tối đa",
请输入买入金额:"Vui lòng nhập số tiền mua",
可用金额:"Số tiền có sẵn",
请输入买入金额:"Vui lòng nhập số tiền mua",
质押金额:"Số tiền cam kết",
累计收益:"Thu nhập tích lũy",
开始时间:"Thời gian bắt đầu",
结束时间:"Thời gian kết thúc",
理财规则:"quy định tài chính",
理财规则1:"Quản lý tài chính được thực hiện bằng cách ủy thác USD cho nền tảng và đội ngũ chuyên nghiệp của nền tảng tiến hành chênh lệch tài chính. Người tham gia có thể nhận được một phần thu nhập quản lý tài chính của nền tảng trong thời gian lưu ký quỹ.",
收益计算:"Tính toán doanh thu",
理财规则2:"Thành viên gửi 10.000U trên nền tảng và chọn sản phẩm tài chính có chu kỳ 5 ngày và thu nhập hàng ngày là 0,3%~0,5%.Thu nhập hàng ngày như sau:",
最低:"thấp nhất",
最高:"Cao nhất",
理财规则3:"Cả hai: bạn có thể nhận được sau 5 ngày",
理财规则4:"Thu nhập được phân phối hàng ngày. Thu nhập được phân phối có thể được truy cập và rút bất cứ lúc nào và gửi vào tiền gốc. Sau khi đáo hạn, nó sẽ tự động được trả lại vào tài khoản của bạn.",
关于违约金:"Về bồi thường thiệt hại",
理财规则5:"Nếu bạn muốn chuyển khoản tiền gốc chưa hết hạn, bạn sẽ phải chịu những thiệt hại được thanh lý.",
理财规则6:"Thiệt hại được thanh lý = tỷ lệ thanh toán x số ngày còn lại x số tiền đầu tư.",
理财规则7:"Ví dụ: Tỷ lệ giải quyết bồi thường thiệt hại của sản phẩm này là",
剩余:"Còn lại",
天到期投资:"Nó hết hạn sau vài ngày và số tiền đầu tư là",
则:"Nhưng",
违约金:"thiệt hại thanh lý",
实际退还本金为:"Tiền gốc thực tế được trả lại là",
现货账户:"tài khoản giao ngay",
总资产:"Tổng tài sản",
充币:"Gửi tiền xu",
提币:"Rút xu",
闪兑:"Trao đổi flash",
投资组合:"danh mục đầu tư",
冻结数量:"số lượng đông lạnh",
帮助中心:"Trung tâm trợ giúp",
自选:"Không bắt buộc",
行情:"Báo giá",
资金:"quỹ",
资讯:"Thông tin",
我的:"của tôi",
交易对:"cặp giao dịch",
最新价:"Giá mới nhất",
成交量:"Âm lượng",
标记价格:"đánh dấu giá",
h24最高价:"giá cao nhất 24h",
h24最低价:"giá thấp nhất 24h",
h24成交量:"Khối lượng giao dịch 24h",
h24交易额:"Khối lượng giao dịch 24h",
分时:"chia sẻ thời gian",
分1:"1 điểm",
分5:"5 điểm",
分15:"15 điểm",
分30:"30 điểm",
小时1:"1 giờ",
天1:"1 ngày",
周1:"1 tuần",
月1:"Tháng Một",
委托订单:"Đặt hàng",
最新交易:"Giao dịch mới nhất",
买入:"Mua",
卖出:"bán",
时间:"thời gian",
方向:"phương hướng",
取消自选成功:"Hủy lựa chọn thành công",
添加成功:"Thêm thành công",
登录:"Đăng nhập",
账户:"Tài khoản",
邮箱:"Thư",
手机号:"Số điện thoại",
请输入账户:"Vui lòng nhập tài khoản",
请输入邮箱:"vui lòng nhập email của bạn",
请输入手机号:"Vui lòng nhập số điện thoại",
密码:"mật khẩu",
请输入密码:"Xin vui lòng nhập mật khẩu",
忘记密码:"quên mật khẩu?",
还没有账号:"Chưa có tài khoản",
去注册:"Đi để đăng ký",
请输入登录账号:"Vui lòng nhập tài khoản đăng nhập của bạn",
请输入登录密码:"Vui lòng nhập mật khẩu của bạn",
登录失败:"Đăng nhập thất bại",
历史记录:"kỷ lục lịch sử",
充值:"nạp tiền",
提现:"rút",
未审核:"Chưa được xem xét",
成功:"thành công",
失败:"thất bại",
快捷入口:"Nhập nhanh",
资金密码:"Mật khẩu quỹ",
登录密码:"mật khẩu đăng nhập",
账变记录:"Hồ sơ thay đổi tài khoản",
邀请推广:"Mời khuyến mãi",
通用:"Phổ quát",
语言:"ngôn ngữ",
在线客服:"dịch vụ trực tuyến",
身份认证:"Xác thực",
高级认证:"Chứng nhận nâng cao",
更多:"Hơn",
帮助中心:"Trung tâm trợ giúp",
关于我们:"về chúng tôi",
退出:"từ bỏ",
已提交身份认证:"Bạn đã gửi thông tin nhận dạng của mình và nó đang được xem xét",
您已完成身份认证:"Bạn đã hoàn tất xác minh danh tính",
您已完成高级认证:"Bạn đã hoàn thành Chứng chỉ nâng cao",
确定退出登录:"Bạn có chắc chắn bạn muốn thoát?",
资讯:"Thông tin",
公告:"thông báo",
状态:"tình trạng",
已成交:"Giao dịch đã xong",
委托金额:"Hoa hồng",
剩余金额:"THĂNG BẰNG",
订单类型:"Kiểu đơn hàng",
市价委托:"đặt hàng ở siêu thị",
限价委托:"lệnh giới hạn",
订单号:"số thứ tự",
委托时间:"Thời gian hoa hồng",
U本位合约历史:"Lịch sử hợp đồng dựa trên U",
成交数量:"Số lượng giao dịch",
实现盈亏:"Thực hiện lãi lỗ",
推广记录:"Kỷ lục thăng hạng",
我的总推广:"Khuyến mãi chung của tôi",
总充值:"Tổng số tiền nạp lại",
一代人数:"Số lượng thế hệ",
二代人数:"Số lượng thế hệ thứ hai",
三代人数:"Số lượng ba thế hệ",
立即推广:"Quảng cáo ngay bây giờ",
我的推广:"sự thăng tiến của tôi",
用户名:"tên tài khoản",
行情:"Báo giá",
加密货币:"tiền điện tử",
外汇:"Ngoại hối",
股票:"Cổ phần",
现货交易:"Giao dịch giao ngay",
期货:"Giao dịch hēs Futures",
热门:"Phổ biến",
涨幅榜:"Danh sách tăng giá",
跌幅榜:"Danh sách thua cuộc",
快速充币:"Gửi tiền nhanh",
保存二维码:"Lưu mã QR",
复制地址:"Sao chép địa chỉ",
转出地址:"Địa chỉ chuyển đi (tùy chọn)",
请输入转出地址:"Vui lòng nhập địa chỉ chuyển đi",
粘贴:"Dán",
充币数量:"Số tiền gửi",
请输入充币数量:"Vui lòng nhập số tiền gửi",
区块链网络:"Mạng chuỗi khối",
付款凭证:"Chứng từ thanh toán (tải lên ảnh chụp màn hình chi tiết thanh toán)",
请输入充值数量:"Vui lòng nhập số tiền nạp",
充值通道:"Kênh nạp tiền",
请选择充值币种:"Vui lòng chọn loại tiền nạp",
官方充值通道:"Kênh nạp tiền chính thức",
设置密码:"đặt mật khẩu",
确认密码:"Xác nhận mật khẩu",
验证码:"Mã xác nhận",
请输入验证码:"vui lòng nhập mã xác nhận",
获取验证码:"lấy mã xác minh",
重新发送:"Gửi lại",
邀请码:"Mã mời",
请输入邀请码:"Vui lòng nhập mã mời",
我已阅读并同意:"tôi đã đọc và đồng ý",
服务条款:"Điều khoản dịch vụ",
注册:"đăng ký",
已有账号:"Bạn co săn san để tạo một tai khoản",
去登录:"Đi đến đăng nhập",
请再次输入密码:"Vui lòng nhập lại mật khẩu",
请同意服务条款:"Vui lòng đồng ý với các điều khoản dịch vụ",
注册失败:"đăng ký thất bại",
欢迎来到:"Chào mừng bạn đến",
全球最大的区块链资产平台:"Nền tảng tài sản blockchain lớn nhất thế giới",
分享二维码:"Chia sẻ mã QR",
链接分享:"Chia sẻ liên kết",
复制:"sao chép",
您的邀请码:"mã mời của bạn",
到数字币地址:"Đến địa chỉ tiền kỹ thuật số",
选择币种:"Chọn loại tiền tệ",
区块链网络:"Mạng chuỗi khối",
提币说明:"Hướng dẫn rút tiền",
提现费用:"Phí rút tiền",
可到账数量:"Số lượng có sẵn",
可用:"Có sẵn",
请输入支付密码:"Vui lòng nhập mật khẩu thanh toán",
请输入提币数量:"Vui lòng nhập số tiền rút",
全部:"tất cả",
支付密码:"Mật khẩu thanh toán",
地址:"Địa chỉ",
委托价:"Giá đặt hàng",
成交时间:"Thời gian giao dịch",
成交金额:"Doanh số",
委托中:"Theo hoa hồng",
持仓中:"Ở vị trí",
平仓中:"Đóng vị thế",
已平仓:"Vị thế đã đóng",
开仓倍数:"Mở nhiều",
委托价格:"Giá hoa hồng",
收盘价:"Giá đóng cửa",
收益率:"tỷ lệ lợi nhuận",
平仓时间:"Thời gian đóng cửa",
请输入转换数量:"Vui lòng nhập số lượng quy đổi",
请上传付款凭证:"Vui lòng tải lên chứng từ thanh toán",
开盘价:"giá mở cửa",
开市中:"Mở",
已休市:"Chợ đã đóng cửa",
美股:"chứng khoán Mỹ",
平仓价:"Giá đóng cửa",
到期结算完成:"Đã hoàn tất thanh toán đáo hạn",
印度股票:"chứng khoán ấn độ",
马来股票:"Cổ phiếu Mã Lai",
结算中:"định cư",
越南股票:"chứng khoán việt nam",
设置资金密码:"Đặt mật khẩu quỹ",
请输入资金密码:"Vui lòng nhập mật khẩu quỹ",
取消:"Hủy bỏ",
确定:"Chắc chắn",
止损价:"Giá dừng lỗ",
请输入止损价格:"Vui lòng nhập giá dừng lỗ",
请输入止盈价格:"Vui lòng nhập giá chốt lời",
止盈价:"Lấy giá lãi",
设置止盈止损:"Đặt chốt lời và dừng lỗ",
请输入关键词:"Vui lòng nhập từ khóa",
搜索结果:"kết quả tìm kiếm",
添加收款方式:"Thêm phương thức thanh toán",
高级认证:"Chứng nhận nâng cao",
历史委托:"hoa hồng lịch sử",
选择区域码:"Chọn mã vùng",
请上传身份证图片:"Vui lòng tải lên hình ảnh chứng minh nhân dân của bạn",
请上传护照照片:"Vui lòng tải lên ảnh hộ chiếu",
请输入提币地址:"Vui lòng nhập địa chỉ rút tiền",
设置语言:"cài đặt ngôn ngữ",
最低金额: "Số tiền tối thiểu",
购买金额: "giá mua",
请输入要搜索的国家名称: "Vui lòng nhập tên quốc gia bạn muốn tìm kiếm",
确定执行该操作: "Xác nhận để thực hiện việc này?",
历史搜索: "Tìm kiếm lịch sử",
现货持仓: "Vị trí điểm",
永续持仓: "Vị trí vĩnh viễn",
到期结算中: "Thanh toán khi đáo hạn",
火花图: "sơ đồ tia lửa",
计价单位: "đơn vị bán hàng",
您拒绝了链接: "Bạn đã từ chối liên kết",
连接钱包成功: "Kết nối ví thành công",
已断开钱包: "Ví đã bị ngắt kết nối",
钱包切换成功: "Chuyển đổi ví thành công",
请先安装钱包插件: "Vui lòng cài đặt plug-in ví trước",
连接钱包: "Kết nối ví",
交易: "buôn bán",
确认报价: "Xác nhận báo giá",
您将获得: "bạn sẽ nhận được",
兑换自: "Đổi từ",
汇率: "tỷ giá",
返回: "trở lại",
兑换: "trao đổi",
消息: "thông tin",
身份证反面照片: "Ảnh mặt sau CMND",
身份证正面照片: "Ảnh mặt trước CMND",
手持身份证照片: "Ảnh cầm CMND",
划转: "chuyển khoản",
请输入划转数量: "Vui lòng nhập số tiền chuyển(USD)",
邀请链接: "Liên kết lời mời",
资料总览: "Tổng quan về dữ liệu",
推广规则: "Quy định khuyến mãi",
总邀请人数: "Tổng số người được mời",
总佣金: "tổng hoa hồng",
安全绑定: "ràng buộc an toàn",
规则1: "1.Địa chỉ này chỉ chấp nhận {type}. Vui lòng không chuyển nội dung không phải {type} sang địa chỉ này, nếu không nội dung sẽ không được lấy lại.",
规则2: "2.Sau khi bạn nạp tiền vào địa chỉ trên, bạn cần đợi nút mạng xác nhận. Sau khi nút mạng xác nhận, tài sản sẽ tự động đến tài khoản của bạn. Chúng tôi sẽ thông báo cho bạn về trạng thái đến dưới dạng thông báo trên trang web.",
规则3: "3.Địa chỉ nạp tiền của bạn sẽ không thay đổi thường xuyên và bạn có thể nạp tiền nhiều lần; nếu có bất kỳ thay đổi nào, chúng tôi sẽ thông báo cho bạn qua thông báo trên trang web",

安全中心: "Trung tâm bảo vệ",
绑定手机号: "Ràng buộc số điện thoại di động",
认证中心: "Trung tâm chứng nhận",
身份认证: "Xác thực",
认证要求: "Yêu cầu chứng nhận",
政府发行的证件: "Văn bản do Chính phủ ban hành",
功能与限制: "Tính năng và hạn chế",
无限额: "Không giới hạn",
预计审核时间: "Thời gian xem xét dự kiến: 60 phút",
开始认证: "Bắt đầu chứng nhận",
充币规则: "Quy tắc gửi tiền",
套期保值: "Phòng ngừa rủi ro, phòng ngừa rủi ro",
登陆后继续: "Đăng nhập để tiếp tục",
客服充值: "Nạp tiền dịch vụ khách hàng",
数字货币: "Tiền kỹ thuật số",
银行取款: "Rút tiền ngân hàng",
请选择充值方式: "Vui lòng chọn phương thức nạp tiền",
请选择取款方式: "Vui lòng chọn phương thức rút tiền",
请输入金额: "Vui lòng nhập số tiền",
银行名称: "Tên ngân hàng",
银行卡号: "Số thẻ ngân hàng",
请输入: "Vui lòng nhập",
请选择: "Vui lòng chọn",
类型: "Loại",
可用金额: "Số tiền khả dụng",
提款: "Rút tiền"
    
}


// WEBPACK FOOTER //
// ./src/lang/vi.js